import React from "react";
import { Link } from "react-router-dom";

const Announcement = () => {
  return (
    <Link
      to="/winners-hub"
      style={{
        display: "block",
        background: "linear-gradient(90deg, #004d99 0%, #0066cc 100%)",
        padding: "12px 0",
        textAlign: "center",
        textDecoration: "none",
        cursor: "pointer",
      }}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "12px",
          color: "#fff",
          fontSize: "0.95rem",
          fontWeight: "500",
        }}
      >
        <span
          style={{
            display: "inline-block",
            padding: "3px 10px",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            borderRadius: "4px",
            fontSize: "0.75rem",
            fontWeight: "700",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          }}
        >
          Announcement
        </span>
        The 2026 IRO Winners have been announced! View the results and claim your
        certificate →
      </span>
    </Link>
  );
};

export default Announcement;
